import { render, staticRenderFns } from "./GenericSelfService.vue?vue&type=template&id=798fd6ea&scoped=true&"
import script from "./GenericSelfService.vue?vue&type=script&lang=js&"
export * from "./GenericSelfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798fd6ea",
  null
  
)

export default component.exports